import { useTranslation } from 'react-i18next';

export default function Comparison() {
  const { t } = useTranslation();

  return (
    <section className="w-full py-20 md:py-28 px-6 md:px-10 bg-background-50">
      <div className="max-w-[1280px] mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-start gap-8 mb-14">
          <div className="lg:w-[35%]">
            <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 leading-tight">
              {t('comparison.title')}
            </h2>
            <p className="text-3xl md:text-4xl font-heading text-foreground-400 mt-1">
              {t('comparison.subtitle')}
            </p>
          </div>
          <div className="lg:w-[65%]">
            <p className="text-base text-foreground-600 leading-relaxed">
              {t('comparison.description')}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          <div className="bg-primary-500 rounded-2xl p-8 text-background-50">
            <h3 className="text-xl font-heading font-semibold mb-6">{t('comparison.spreadsheet')}</h3>
            <div className="space-y-5">
              {[
                { feature: 'comparison.feature1', stars: 5 },
                { feature: 'comparison.feature2', stars: 5 },
                { feature: 'comparison.feature3', stars: 5 },
                { feature: 'comparison.feature4', stars: 5 },
              ].map((item) => (
                <div key={item.feature} className="flex items-center justify-between">
                  <span className="text-sm text-background-50/90">{t(item.feature)}</span>
                  <span className="flex gap-0.5">
                    {Array.from({ length: item.stars }).map((_, i) => (
                      <i key={i} className="ri-star-fill text-accent-400 text-sm"></i>
                    ))}
                  </span>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-background-100 rounded-2xl p-8 border border-background-200/60">
            <h3 className="text-xl font-heading font-semibold text-foreground-950 mb-6">
              {t('comparison.traditional')}
            </h3>
            <div className="space-y-5">
              {[
                { feature: 'comparison.feature1', stars: 2 },
                { feature: 'comparison.feature2', stars: 1 },
                { feature: 'comparison.feature3', stars: 1 },
                { feature: 'comparison.feature4', stars: 1 },
              ].map((item) => (
                <div key={item.feature} className="flex items-center justify-between">
                  <span className="text-sm text-foreground-600">{t(item.feature)}</span>
                  <span className="flex gap-0.5">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i
                        key={i}
                        className={`text-sm ${i < item.stars ? 'ri-star-fill text-secondary-400' : 'ri-star-line text-foreground-300'}`}
                      ></i>
                    ))}
                  </span>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-background-100 rounded-2xl p-8 border border-background-200/60 flex flex-col justify-center items-center text-center">
            <div className="w-16 h-16 rounded-full bg-accent-100 flex items-center justify-center mb-4">
              <i className="ri-trophy-line text-2xl text-accent-500"></i>
            </div>
            <p className="text-lg font-heading font-semibold text-foreground-950 mb-2">
              {t('comparison.spreadsheet')}
            </p>
            <p className="text-3xl font-bold text-primary-500">5x</p>
            <p className="text-sm text-foreground-500 mt-1">szybciej niż ręczne szukanie</p>
          </div>
        </div>
      </div>
    </section>
  );
}